let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jDLw3")).then(() => parcelRequire('3RUZF'));